<script setup lang="ts">
import { onMounted, ref, watch } from 'vue'
import GbButton from '@/components/GbButton.vue'
import generatingAnimation from '@/assets/ai_transition_animation.gif'

const props = withDefaults(defineProps<{
  generationError?: string
}>(), {
  generationError: '',
})

const emit = defineEmits<{
  retry: []
  cancel: []
}>()

const errorActions = ref<HTMLElement | null>(null)

function focusRetryWhenFailed() {
  if (props.generationError) {
    errorActions.value?.querySelector('button')?.focus()
  }
}

onMounted(focusRetryWhenFailed)
watch(() => props.generationError, focusRetryWhenFailed, { flush: 'post' })
</script>

<template>
  <div>
    <div class="absolute top-0 h-full w-full bg-white opacity-75" />
    <div class="absolute top-0 flex h-full w-full items-center justify-center">
      <div class="w-64 rounded-xl bg-gradient-to-r from-ai-bluePinkStart from-50% to-ai-bluePinkStop pt-3 shadow-lg">
        <div class="h-64 rounded-b-xl bg-white p-4 text-center text-lg">
          <div v-if="generationError" class="flex h-full flex-col items-center justify-evenly" data-testid="sdi-generation-error">
            <p role="alert">{{ generationError }}</p>
            <div ref="errorActions" class="flex gap-1">
              <GbButton gb-theme="bluePrimary" size="xs" @click="emit('retry')">Retry</GbButton>
              <GbButton gb-theme="grayOutlineSecondary" size="xs" @click="emit('cancel')">Cancel</GbButton>
            </div>
          </div>
          <div v-else data-testid="sdi-generating">
            <img class="h-auto w-full" :src="generatingAnimation" alt="AI Powered Feature">
            <p role="status">
              Compiling Goalbook Toolkit strategies...<span class="sr-only">Please wait a moment.</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
